import React, { useState } from "react";
import PropTypes from "prop-types";

function FileChooser(props) {
  const [file, setFile] = useState(null);

  const handleChange = (event) => {
    props.changeHandler(event.target.files[0]);
  };

  // if having spacing problems in Data module, the "style" attribute is the problem.  Change this and the attachment load breaks
  return (
    <div style={{ display: "inline-block", verticalAlign: "bottom" }}>
      &nbsp;
      <input
        type="file"
        //value={file}
        accept={props.fileExtension}
        name={props.name}
        hidden={props.isHidden}
        onChange={handleChange}
        disabled={props.isDisabled ? true : false}
      ></input>
    </div>
  );
}

export default FileChooser;

FileChooser.propTypes = {
  changeHandler: PropTypes.func,
  fileExtension: PropTypes.string,
  name: PropTypes.string,
  isHidden: PropTypes.bool,
  isDisabled: PropTypes.bool,
};
